import React, { Component } from "react";
import { Link } from "react-router-dom";
import TopBar from "../__shared__/TopBar";
import ProfileMenu from "../__shared__/ProfileMenu";
import StepMarkerBar from "../__shared__/StepMarkerBar";
import PreviousStepButton from "../__shared__/PreviousStepButton";
import NextStepButton from "../__shared__/NextStepButton";
import { connect } from "react-redux";
import {
    SEG_MRI_STEP,
    BIOPSY_STEP,
    EDIT_MARGIN_STEP,
} from "../CreateTPlan_1Upload/constants";
import {
    setCurrentTreatmentPlan,
    setStepActive,
    setStepComplete,
} from "../CreateTPlan_1Upload/actions";
import "./styles.css";
import {
    getPHISignedURLS3,
    updateTreatmentPlan,
} from "../../helpers/backend_api";
import {
    setBiopsyError,
    setCoreLocations,
    setPathReportURL,
    setPathSummaryURL,
    setTemplateURL,
} from "./actions";
import {
    getMaxGleasonGradeGroupFromCores,
    isAnyCorePositiveCheck,
} from "./helpers";
import { computeBiopsyButtonLocations } from "./biopsy_button_calc";
import PathologyTable from "./PathologyTable";
import {
    pageLoadStates,
    stepPath,
    clientErrorMessages,
    sceneOrientations,
} from "../../constants";
import { getPlan } from "../CreateTPlan_1Upload/helpers";
import RequirementsModal from "../__shared__/RequirementsModal";
import { getLoadingScreen, getSignedUrl } from "../../helpers/helpers";
import PropTypes from "prop-types";
import { EMPTY_STRING } from "../../constants";
import { setErrorState } from "../../redux/error_banner/actions";
import { rootStore } from "../../redux/store";
import * as TreatmentPlan from "../../helpers/tplan/tplan";
import BiopsyCompleteAlertHandler from "./BiopsyCompleteAlertHandler";
import { If, Then } from "react-if";
import BiopsyPlotContainer from "./BiopsyPlotContainer";
import MRIModel from "../__shared__/Viewers/Structures/MRI/MRIModel";
import MRIController from "../__shared__/Viewers/Structures/MRI/MRIController";
import PatientAnatomyModel from "../__shared__/Viewers/Structures/PatientAnatomy/PatientAnatomyModel";
import PatientAnatomyController from "../__shared__/Viewers/Structures/PatientAnatomy/PatientAnatomyController";
import {
    loadBxCores,
    loadMri,
    loadProstate,
    loadROIs,
} from "../../helpers/load_helpers";
import { setDebugHooks } from "../../helpers/debug/debug_hooks";
import MeshViewer from "../__shared__/Viewers/MeshViewer";
import BiopsyTemplateFrame from "./BiopsyTemplateFrame";
import ResetViewerButton from "../__shared__/ResetViewerButton";
import { RESET_VIEW } from "./constants";
import blueResetArrow from "../../assets/ccw_btn_blue.svg";
import PDFViewerWrapper from "./PDFViewerWrapper";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";

const MS_PER_MINUTE = 60 * 1000;
const SIGNED_URL_REFRESH_INTERVAL_MS = 4 * MS_PER_MINUTE;

class CreateTPlan_3Biopsy extends Component {
    constructor(props) {
        super(props);
        this.nextStep = this.nextStep.bind(this);
        this.prevStep = this.prevStep.bind(this);
        this.requirements = {
            required: [
                {
                    id: "label-biopsy-req",
                    satisfied: false,
                    reqText:
                        "Label Biopsy Cores according to the Pathology Report",
                    listIndex: 1,
                },
            ],
            optionals: [],
        };

        this.state = {
            coreLoadState: pageLoadStates.LOADING,
            pdfLoadState: pageLoadStates.LOADING,
            meshViewerLoadState: pageLoadStates.LOADING,
            showAlerts: false,
        };

        this.meshRef = React.createRef();
        this.biopsyPlotContainerRef = React.createRef();
        this.pathSummaryRefreshInterval = null;
        this.pathReportRefreshInterval = null;
        this.templateRefreshInterval = null;

        const smallViewerCameraDistance = 150;
        this.mriModel = new MRIModel(false, smallViewerCameraDistance);
        this.mriModel.visibility = false;
        this.mriController = new MRIController(this.mriModel);
        this.patientAnatomyModel = new PatientAnatomyModel();
        this.patientAnatomyController = new PatientAnatomyController(
            this.patientAnatomyModel
        );

        setDebugHooks({
            mriModel: this.mriModel,
            patientAnatomyModel: this.patientAnatomyModel,
        });

        this.verifyBiopsyDataCallback =
            this.verifyBiopsyDataCallback.bind(this);
        this.setPdfLoaded = this.setPdfLoaded.bind(this);
        this.getLoadedState = this.getLoadedState.bind(this);
        this.callBiopsyPlotContainerFunction =
            this.callBiopsyPlotContainerFunction.bind(this);
    }

    componentDidMount() {
        let scope = this;
        getPlan(
            this.props.authToken,
            this.props.patientuuid,
            this.props.planuuid
        )
            .then((payload) => payload.json())
            .then((json) => {
                let plan = json.payload.plan.TreatmentPlan;
                scope.props.setCurrentTreatmentPlan(json.payload.plan);

                let cores = computeBiopsyButtonLocations(plan);
                scope.props.setCoreLocations(cores);
                scope.getMRIURLs(json.payload.plan);
                scope.getMeshURLs(json.payload.plan);
                scope.setState({ coreLoadState: pageLoadStates.COMPLETE });

                const pathSummaryURI =
                    plan.PatientData?.PathologySummaryData?.PathologySummaryURI;
                if (pathSummaryURI?.length > 1) {
                    this.fetchPathSummary(pathSummaryURI);
                    this.pathSummaryRefreshInterval = setInterval(() => {
                        this.fetchPathSummary(pathSummaryURI);
                    }, SIGNED_URL_REFRESH_INTERVAL_MS);
                }
            })
            .catch(() => {
                scope.setState({ coreLoadState: pageLoadStates.COMPLETE });
            });

        const pathologyReportURI =
            this.props.currentTreatmentPlan?.TreatmentPlan?.PatientData
                .PathologyReportURI;
        const templateURI =
            this.props.currentTreatmentPlan?.TreatmentPlan?.PatientData
                ?.TemplateURI;

        if (pathologyReportURI?.length > 1) {
            this.fetchPathReport(pathologyReportURI);
            this.pathReportRefreshInterval = setInterval(() => {
                this.fetchPathReport(pathologyReportURI);
            }, SIGNED_URL_REFRESH_INTERVAL_MS);
        }

        if (templateURI?.length > 1) {
            this.fetchTemplate(templateURI);
            this.templateRefreshInterval = setInterval(() => {
                this.fetchTemplate(templateURI);
            }, SIGNED_URL_REFRESH_INTERVAL_MS);
        }

        if (templateURI?.length < 1 && pathologyReportURI?.length < 1) {
            this.setPdfLoaded(pageLoadStates.FAILED);
        }
    }

    fetchPathReport(pathologyReportURI) {
        getPHISignedURLS3({
            token: this.props.authToken,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            uris: [pathologyReportURI],
        })
            .then((payload) => payload.json())
            .then((json) => {
                const url = getSignedUrl(json.payload.signedurls);
                if (url) {
                    this.props.setPathReportURL(url);
                    this.setPdfLoaded(pageLoadStates.COMPLETE);
                } else {
                    this.setPdfLoaded(pageLoadStates.COMPLETE);
                }
            })
            .catch(() => {
                this.setPdfLoaded(pageLoadStates.FAILED);
                this.setBannerError(
                    true,
                    clientErrorMessages.PATH_REPORT_LOAD_FAILED
                );
            });
    }

    fetchTemplate(templateURI) {
        getPHISignedURLS3({
            token: this.props.authToken,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            uris: [templateURI],
        })
            .then((payload) => payload.json())
            .then((json) => {
                const url = getSignedUrl(json.payload.signedurls);
                if (url) {
                    this.props.setTemplateURL(url);
                }
            })
            .catch(() => {
                this.setPdfLoaded(pageLoadStates.FAILED);
                this.setBannerError(
                    true,
                    clientErrorMessages.PATH_TEMPLATE_LOAD_FAILED
                );
            });
    }

    fetchPathSummary(pathSummaryURI) {
        getPHISignedURLS3({
            token: this.props.authToken,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            uris: [pathSummaryURI],
        })
            .then((payload) => payload.json())
            .then((json) => {
                const url = getSignedUrl(json.payload.signedurls);
                if (url) {
                    this.props.setPathSummaryURL(url);
                }
            })
            .catch(() => {
                this.setPdfLoaded(pageLoadStates.COMPLETE);
                this.setBannerError(
                    true,
                    clientErrorMessages.PATH_SUMMARY_LOAD_FAILED
                );
            });
    }

    getMeshURLs(plan) {
        const ids = {
            token: this.props.authToken,
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            visituuid: this.props.visituuid,
        };

        loadBxCores({
            ids,
            plan,
            patientAnatomyModel: this.patientAnatomyModel,
        });

        loadProstate({
            plan,
            ids,
            patientAnatomyModel: this.patientAnatomyModel,
            createBoundingCone: false,
            createAxes: true,
            setLoadState: (newState) =>
                this.setState({ meshViewerLoadState: newState }),
        });
        loadROIs({
            plan,
            ids,
            patientAnatomyModel: this.patientAnatomyModel,
            patientAnatomyController: this.patientAnatomyController,
        });
    }

    getMRIURLs(plan) {
        const ids = {
            token: this.props.authToken,
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            visituuid: this.props.visituuid,
        };

        loadMri({
            ids,
            currentTreatmentPlan: plan,
            mriModel: this.mriModel,
            loadState: this.state.meshViewerLoadState,
            setLoadState: (newState) =>
                this.setState({ meshViewerLoadState: newState }),
            sceneOrientation: sceneOrientations.CORONAL,
        });
    }

    componentWillUnmount() {
        if (this.pathSummaryRefreshInterval) {
            clearInterval(this.pathSummaryRefreshInterval);
            this.pathSummaryRefreshInterval = null;
        }
        if (this.pathReportRefreshInterval) {
            clearInterval(this.pathReportRefreshInterval);
            this.pathReportRefreshInterval = null;
        }
        if (this.templateRefreshInterval) {
            clearInterval(this.templateRefreshInterval);
            this.templateRefreshInterval = null;
        }
        this.props.setPathReportURL("");
        this.props.setPathSummaryURL("");
        this.props.setTemplateURL("");
    }

    prevStep() {
        this.props.setStepActive(BIOPSY_STEP, false);
        this.props.setStepComplete(BIOPSY_STEP, false);
        this.props.setStepActive(SEG_MRI_STEP, true);

        let plan = this.props.currentTreatmentPlan;
        plan.SavedData.PlanCreationStep = SEG_MRI_STEP;
        this.props.setCurrentTreatmentPlan(plan);

        updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        });
    }

    nextStep(stepPath) {
        if (isAnyCorePositiveCheck(this.props.currentTreatmentPlan)) {
            let scope = this;
            let plan = this.props.currentTreatmentPlan;
            plan.SavedData.PlanCreationStep = EDIT_MARGIN_STEP;
            plan.TreatmentPlan.PatientData.GleasonGradeGroup =
                getMaxGleasonGradeGroupFromCores(
                    TreatmentPlan.getBiopsyCores(plan.TreatmentPlan)
                );

            updateTreatmentPlan({
                useruuid: this.props.useruuid,
                patientuuid: this.props.patientuuid,
                planuuid: this.props.planuuid,
                token: this.props.authToken,
                plan: plan,
            })
                .catch(() => {
                    this.setBannerError(
                        true,
                        clientErrorMessages.TPLAN_UPDATE_FAILED
                    );
                })
                .finally(() => {
                    scope.props.history.push(stepPath);
                    scope.props.setStepComplete(BIOPSY_STEP, true);
                    scope.props.setStepActive(BIOPSY_STEP, false);
                    scope.props.setStepActive(EDIT_MARGIN_STEP, true);
                    scope.props.setCurrentTreatmentPlan(plan);
                });

            return true;
        } else {
            this.requirementsModalRef.openModal();
        }
        return false;
    }

    getRequirements() {
        this.requirements.required[0].satisfied = isAnyCorePositiveCheck(
            this.props.currentTreatmentPlan
        );
        return this.requirements;
    }

    checkErrorPresent() {
        setTimeout(() => true, 1000);
    }

    async verifyBiopsyDataCallback() {
        document.activeElement.blur();

        await this.checkErrorPresent();

        if (isAnyCorePositiveCheck(this.props.currentTreatmentPlan)) {
            this.setState({
                showAlerts: true,
            });
            return true;
        } else if (this.requirementsModalRef.state.modalOpen) {
            this.requirementsModalRef.closeModal();
            return false;
        } else {
            this.requirementsModalRef.openModal();
            return false;
        }
    }

    setPdfLoaded(pageLoadState) {
        this.setState({ pdfLoadState: pageLoadState });
    }

    getLoadedState() {
        if (
            this.state.coreLoadState === pageLoadStates.COMPLETE &&
            (this.state.pdfLoadState === pageLoadStates.COMPLETE ||
                this.state.pdfLoadState === pageLoadStates.FAILED) &&
            this.state.meshViewerLoadState === pageLoadStates.COMPLETE
        ) {
            return pageLoadStates.COMPLETE;
        }
        if (this.state.coreLoadState === pageLoadStates.FAILED) {
            return pageLoadStates.FAILED;
        }

        return pageLoadStates.LOADING;
    }

    setBannerError(hasError, errMsg) {
        rootStore.dispatch(setErrorState(hasError, errMsg));
    }

    callBiopsyPlotContainerFunction() {
        if (this.biopsyPlotContainerRef.current) {
            this.biopsyPlotContainerRef.current.callBiopsyPlotFunction();
        }
    }

    resetViewer() {
        // Reset 3D Mesh Viewer
        this.meshRef.current.resetScene();
    }

    render() {
        let lhmDeleteInput = {
            patientuuid: this.props.patientuuid,
            visituuid: this.props.visituuid,
            fileURI: this.props.currentTreatmentPlan.SavedData.CPMURI,
            token: this.props.authToken,
        };

        return (
            <div className={"create-plan-biopsy-screen"}>
                <TopBar>
                    <Link to={stepPath.HOME}>
                        <UnfoldLogo />
                    </Link>
                    <div className={"create-plan-step-bar-container"}>
                        <div className={"step-bar-prev-btn-group"}>
                            <PreviousStepButton
                                to={stepPath.STEP2}
                                callback={this.prevStep}
                                isReady={
                                    this.state.coreLoadState !==
                                    pageLoadStates.LOADING
                                }
                            />
                            <StepMarkerBar />
                        </div>
                        <NextStepButton
                            reqsComplete={isAnyCorePositiveCheck(
                                this.props.currentTreatmentPlan
                            )}
                            reqsCompleteTxt={"Verify Data"}
                            to={stepPath.STEP3}
                            noLink={true}
                            callback={this.verifyBiopsyDataCallback}
                        />
                    </div>
                    <ProfileMenu />
                </TopBar>
                {getLoadingScreen(this.getLoadedState())}
                <RequirementsModal
                    onRef={(ref) => (this.requirementsModalRef = ref)}
                    requirements={this.getRequirements()}
                    showBiopsyTemplateSelector
                />
                <div className="biopsy-screen-body">
                    <PDFViewerWrapper
                        setPdfLoaded={this.setPdfLoaded}
                        currentTreatmentPlan={this.props.currentTreatmentPlan}
                    />
                    <BiopsyTemplateFrame
                        currentTreatmentPlan={this.props.currentTreatmentPlan}
                    >
                        <BiopsyPlotContainer
                            ref={this.biopsyPlotContainerRef}
                        />
                        <div className="mesh-viewer-frame">
                            <ResetViewerButton
                                toolTipText={RESET_VIEW}
                                style={{
                                    position: "absolute",
                                    top: "12px",
                                    right: "15px",
                                    zIndex: "1",
                                }}
                                width={"35px"}
                                imgBlue={blueResetArrow}
                                resetViewer={() => this.resetViewer()}
                            />
                            <MeshViewer
                                style={{
                                    position: "absolute",
                                    left: "0px",
                                    top: "0px",
                                }}
                                ref={this.meshRef}
                                staticViewer={true}
                                displaySettings={{
                                    mriEnabled: false,
                                    composerEnabled: true,
                                }}
                                mriModel={this.mriModel}
                                mriController={this.mriController}
                                patientAnatomyModel={this.patientAnatomyModel}
                                patientAnatomyController={
                                    this.patientAnatomyController
                                }
                                activateCoreClick={true}
                            />
                        </div>
                        <If
                            condition={
                                this.state.coreLoadState ===
                                pageLoadStates.COMPLETE
                            }
                        >
                            <Then>
                                <PathologyTable
                                    dataLoaded={this.state.coreLoadState}
                                    meshViewer={this.meshRef}
                                    biopsyPlot={this.biopsyPlotContainerRef}
                                    currentTreatmentPlan={
                                        this.props.currentTreatmentPlan
                                    }
                                    activeCore={this.props.activeCore}
                                    setActiveCore={this.props.setActiveCore}
                                    patientAnatomyController={
                                        this.patientAnatomyController
                                    }
                                    updateBiopsyPlot={
                                        this.callBiopsyPlotContainerFunction
                                    }
                                />
                            </Then>
                        </If>
                    </BiopsyTemplateFrame>
                </div>
                <If condition={this.state.showAlerts}>
                    <Then>
                        <BiopsyCompleteAlertHandler
                            step3CompleteCallback={this.nextStep}
                            setLHMError={this.setBannerError}
                            setAlertState={(alertState) => {
                                this.setState({ showAlerts: alertState });
                            }}
                            lhmDeleteInput={lhmDeleteInput}
                            currentTreatmentPlan={
                                this.props.currentTreatmentPlan
                            }
                            setCurrentTreatmentPlan={
                                this.props.setCurrentTreatmentPlan
                            }
                        />
                    </Then>
                </If>
            </div>
        );
    }
}

CreateTPlan_3Biopsy.propTypes = {
    authToken: PropTypes.string,
    useruuid: PropTypes.string,
    patientuuid: PropTypes.string,
    planuuid: PropTypes.string,
    visituuid: PropTypes.string,
    setStepActive: PropTypes.func,
    setStepComplete: PropTypes.func,
    currentTreatmentPlan: PropTypes.object,
    setCurrentTreatmentPlan: PropTypes.func,
    setPathReportURL: PropTypes.func,
    setPathSummaryURL: PropTypes.func,
    setTemplateURL: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
    activeCore: PropTypes.number,
    setActiveCore: PropTypes.func,
    setBiopsyError: PropTypes.func,
    bxError: PropTypes.string,
};

CreateTPlan_3Biopsy.defaultProps = {
    useruuid: EMPTY_STRING,
    patientuuid: EMPTY_STRING,
    planuuid: EMPTY_STRING,
    visituuid: EMPTY_STRING,
    location: {},
    bxError: EMPTY_STRING,
};

const mapStateToProps = function (state) {
    return {
        activeCore: state.CreatePlanBiopsyReducer.activeCore,
        useruuid: state.LoginReducer.useruuid,
        authToken: state.LoginReducer.authToken,
        visituuid: state.CreatePlanReducer.visituuid,
        patientuuid: state.CreatePlanReducer.patientuuid,
        planuuid: state.CreatePlanReducer.planuuid,
        currentTreatmentPlan: state.CreatePlanReducer.currentTreatmentPlan,
        bxError: state.CreatePlanBiopsyReducer.bxError,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setCurrentTreatmentPlan: (plan) =>
            dispatch(setCurrentTreatmentPlan(plan)),
        setStepActive: (stepIdx, isActive) =>
            dispatch(setStepActive(stepIdx, isActive)),
        setStepComplete: (stepIdx, isComplete) =>
            dispatch(setStepComplete(stepIdx, isComplete)),
        setPathReportURL: (url) => dispatch(setPathReportURL(url)),
        setPathSummaryURL: (url) => dispatch(setPathSummaryURL(url)),
        setTemplateURL: (url) => dispatch(setTemplateURL(url)),
        setCoreLocations: (cores) => dispatch(setCoreLocations(cores)),
        setBiopsyError: (bxError) => dispatch(setBiopsyError(bxError)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateTPlan_3Biopsy);
